import styled from 'styled-components'

export const StyledNewsAlertName = styled.div``
